import { Component, OnChanges, OnDestroy } from '@angular/core';
import { Input } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Subscription } from 'rxjs';

import { AppConstants } from '@unpispas/upp-defs';
import { PriceInfo, PriceType } from '@unpispas/upp-defs';

import { alertService } from '@unpispas/upp-base';
import { languageService } from '@unpispas/upp-base';
import { dataService } from '@unpispas/upp-data';
import { i18nSupport } from '@unpispas/upp-data';
import { ViewRenderer } from '@unpispas/upp-wdgt';
import { viewService } from '@unpispas/upp-base';

import { PlaceView } from '@unpispas/upp-data';
import { TicketView } from '@unpispas/upp-data';
import { DiscountView } from '@unpispas/upp-data';

/****************************/
/* UPP-OFFER-TICKET         */
/****************************/

@Component({
    selector: 'upp-discount-thumb',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-thumb.html',
    styleUrls: [
      './upp-thumb.scss'
    ],
    providers: [{
        provide: ViewRenderer,
        useFactory: (change: ChangeDetectorRef) => new ViewRenderer(change),
        deps: [ChangeDetectorRef]
    }]       
})
export class UppDiscountThumbComponent extends i18nSupport implements OnChanges, OnDestroy {
    @Input() discount: DiscountView | null = null;
    @Input() ticket: TicketView | null = null;

    private _discount_subscription: Subscription | null = null;

    constructor(private lang: languageService, private change: ViewRenderer, private alertCtrl: alertService, private data: dataService, public view: viewService){
        super(lang, change.cdref);
    }    

    get place(): PlaceView | null {
        return this.discount?.place || null;
    }

    ngOnChanges(){
        if (this._discount_subscription){
            this._discount_subscription.unsubscribe();
            this._discount_subscription = null;
        }

        if (this.discount){
            this._discount_subscription = this.discount.OnViewRefresh.subscribe(
            () => {
                this.change.markForCheck();
            });
        }
    }

    ngOnDestroy(): void {
        super.OnDestroy();

        if (this._discount_subscription){
            this._discount_subscription.unsubscribe();
            this._discount_subscription = null;
        }
    }   
    
    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/

    private _ticketdiscount: PriceType | null = null;
    get chargeinfo(): PriceType | null {
        if (!this._ticketdiscount){
            if (!this.ticket || !this.discount){
                return null;
            }
    
            const _p = this.discount.ChargeAmount(this.ticket);
            const _r = (this.place?.taxrate ?? AppConstants.defaultTaxRate);

            this._ticketdiscount = new PriceInfo(_p, _r).price;
            
            // keep the value during this event loop
            Promise.resolve().then(() => {
                this._ticketdiscount = null;
            });    
        }

        return this._ticketdiscount;
    }
}